import React from 'react';
import { useFormContext, get } from 'react-hook-form';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var ErrorMessage = function (_a) {
    var as = _a.as, errors = _a.errors, name = _a.name, message = _a.message, render = _a.render, rest = __rest(_a, ["as", "errors", "name", "message", "render"]);
    var methods = useFormContext();
    var error = get(errors || methods.errors, name);
    if (!error) {
        return null;
    }
    var messageFromRegister = error.message, types = error.types;
    var props = __assign(__assign({}, rest), { children: messageFromRegister || message });
    return as ? (React.isValidElement(as) ? (React.cloneElement(as, props)) : (React.createElement(as, props))) : render ? render({
        message: messageFromRegister || message,
        messages: types,
    }) : (React.createElement(React.Fragment, __assign({}, props)));
};

export { ErrorMessage };
//# sourceMappingURL=index.esm.js.map
